import React, { FC } from 'react'

import { SH1, Stack, YStack } from '@zet/design-system'
import { BottomSheet } from '@zet/design-system/bottomSheet'
import { i18n } from '@zet/feature-credit-score/localization'

import { CREDIT_SCORE_DATA } from '../utils/constants'
import CreditScoreLevelCard from './creditScoreLevelCard'

interface ICreditInfoBottomSheet {
  visible: boolean
  onDismiss: () => void
  bureau: 'CRIF' | 'EXPERIAN'
}
const CreditInfoBottomSheet: FC<ICreditInfoBottomSheet> = ({
  visible,
  onDismiss,
  bureau,
}) => {
  return (
    <BottomSheet
      visible={visible}
      disableBottomSheet={onDismiss}
      onDismiss={onDismiss}
      sheetName="homepage_new_credit_score"
    >
      <YStack>
        <SH1 className="p-3">{i18n.t('creditScoreInfo')}</SH1>
        <Stack>
          {CREDIT_SCORE_DATA.map((value) => (
            <CreditScoreLevelCard bureau={bureau} level={value} key={value} />
          ))}
        </Stack>
      </YStack>
    </BottomSheet>
  )
}

export default CreditInfoBottomSheet
